



















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































    import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
    import { getLotsPrescriber, getKochise, postLotsArchivePrescriber } from '@/api/api';
    import MetaDatatable from '@/models/MetaDatatable';
    import Program from '@/models/Program';
    import Lot from '@/models/Lot';
    import { formatLotType, formatLotStatus } from '@/data/lot';
    import { BACKEND_URL } from '@/helpers/constants';
    import { buildDocumentUrl } from '@/helpers/document';
    import TableHeaderSorter from '@/components/common/TableHeaderSorter.vue';
    import { typesArr, types2Arr } from '@/data/types';
    import range from 'lodash/range';
    import Lightbox from '@/components/Lightbox.vue';
    import { documentTypes } from '@/data/documentTypes';
    import { families } from '@/data/civilitiesCustomer';
    import Lots from '../Lots.vue';
    import {getTaxSystemKochise, getZoneKochise} from '@/data/kochiseFilters';
    import RentCalculator from '@/components/prescriber/RentCalculator.vue';
    import DeptRatioCalculator from '@/components/prescriber/DeptRatioCalculator.vue';
    import ListModule from '@/store/ListModule';
    import sendDocModal from "@/components/prescriber/SendDocModal.vue";
    import AuthModule from '@/store/AuthModule';
    import { getTaxSystemColor } from '@/data/taxSystems';
    import getOptionInfos from '../../utils/notifications';
    import BRSModal from '@/components/prescriber/BRSModal.vue';
    import {isBrs} from '@/utils/isBrs'
    import ProgramReportModal from '@/components/prescriber/ProgramReportModal.vue';

    import { exposures } from '@/data/types';


    function formatPrice(value: number) {
        return `${Math.floor(value / 1000)}k`;
    }

    @Component({
        components: {
            TableHeaderSorter,
            Lightbox,
            sendDocModal,
            RentCalculator,
            ProgramReportModal,
            DeptRatioCalculator,
            BRSModal
        },
        filters: {
            formatLotType,
            formatLotStatus,
            getKochiseTaxSystem: function(tax_system: string) {
                return getTaxSystemKochise(tax_system);
            },
            getZone: function(zone: string) {
                return getZoneKochise(zone);
            },
            digits: function (limit: number) {
                let nb = Math.round(limit*100)/100
                return nb.toFixed(2)
            },
            euro: function(value: number) {
                return (value != null) ? new Intl.NumberFormat('fr-FR', {
                    style: 'currency',
                    currency: 'EUR',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 0,
                }).format(value) : '';
            },
            fullOwnership: function(lot: Lot) {
                if(lot.full_ownership_amount && lot.discount_rate) {
                    return Math.round(lot.full_ownership_amount / lot.discount_rate) + ' €';
                } else {
                    return 'NC';
                }
            },
            formatYMD: (value: string) => {
                let d = new Date(value);
                let mo = new Intl.DateTimeFormat('en', { month: '2-digit' }).format(d);
                let da = new Intl.DateTimeFormat('en', { day: '2-digit' }).format(d);
                return `(${da}-${mo})`;
            },
            twoDigits: function(value: number) {
                return Math.round(value * 100) / 100
            },
            calculGarantRent: function(lot: Lot){
                if(lot.price && lot.profitability){
                    return Math.floor(lot.price * (lot.profitability / 100) / 12)+'€/mois';
                }
            },
            calculAmountFurnitureLmnp(lot: Lot){
                if(lot.price && lot.location_amount_property){
                    return Math.floor(lot.price - lot.location_amount_property)+' €';
                }
            },
            calculateProfit: function(lot: any){
                if (!isNaN(lot.rent_limit_pinel)){
                    let rent = ((lot.rent_limit_pinel * 12) / lot.price) * 100 ;
                    return new Intl.NumberFormat('fr-FR', {
                        maximumFractionDigits: 1,
                    }).format(rent) + "%";
                }

                if (isNaN(lot.profitability)) {
                    return '';
                }

                return new Intl.NumberFormat('fr-FR', {
                    maximumFractionDigits: 1,
                }).format(lot.profitability) + "%";

                // let rentLimit: any = 0;
                // if(lot.program && lot.program.address && lot.program.address.zone && lot.surface_carrez) {
                //     let perM: number = get(rentLimits, lot.program.address.zone, lot.program.address.zone);
                //     let surface: number = 0;
                //     if(lot.surface_terrace && lot.floor !== 'RDC' && lot.floor  !== 'RDJ') {
                //         if(lot.surface_terrace >= 9) {
                //             surface = lot.surface_carrez + 4.5;
                //         } else {
                //             surface = lot.surface_carrez + (lot.surface_terrace/2);
                //         }
                //     } else {
                //         surface = lot.surface_carrez;
                //     }
                //     let limit = (perM * (0.7 + (19/surface))) * surface;
                //     let nb = Math.round(limit*100)/100
                //     rentLimit = nb.toFixed(2)
                // }
                //
                // if(lot.price && rentLimit !== 0) {
                //     let profit = ((12 * rentLimit) / lot.price)*100;
                //     let nb = Math.round(profit*100)/100
                //     return '~' + nb.toFixed(2)
                // }
                // return 'NC'
            },
            percent: function(value: number) {
                if (isNaN(value)) {
                    return '';
                }

                return new Intl.NumberFormat('fr-FR', {
                    maximumFractionDigits: 2,
                }).format(value);
            },
        },
    })
    export default class ProgramLots extends Vue {
        BACKEND_URL = BACKEND_URL;
        imageModal: string | null = null;
        brsOpen: boolean = false;

        planUrl(plan: any) {
            return buildDocumentUrl(this.BACKEND_URL, plan);
        }

        showLoyerGarantiInfo: boolean = false;
        showPrixTotalTTCInfo: boolean = false;

        @Prop() program!: Program;
        meta: MetaDatatable = {
            total: 0,
            pages: 0,
            page: 0,
            perPage: 20,
            search: null,
            orderBy: null,
            orderWay: null,
            filters: {
                price: null,
                type: null,
                type2: null,
            },
        };

        brs(lot: Lot) {
            return isBrs(lot, this.program)
        }

        lots: Lot[] = [];
        lotStatusColors = {
            acted: '#E26667',
            booked: '#F8B170',
            optionned: '#6CA6D9',
            available: '#66A756',
        };
        loadingContent: boolean = false;
        typesArr = typesArr;
        types2Arr = types2Arr;
        marks: any = null;
        defaultValue: number[] | null = null;
        min: number | null = null;
        max: number | null = null;
        rangeValue: number[] | null = null;
        lotsSelected: Lot[] = [];

        situations: any = {
            0: 'célibataire/divorcé',
            1: 'célibataire/divorcé en concubinage',
            2: 'veuf/ve avec enfant non issu du conjoint décédé',
            3: 'veuf/ve avec enfant issu du conjoint décédé',
            4: 'Marié ou Pacsé'
        }
        kochise: boolean = false;
        notAnnual: boolean = false;
        notSubscribed: boolean = false;
        notKochiseActivated: boolean = false;
        kochiseProspect: any = {
            lastname: '',
            firstname: '',
            postal_code: '',
            situation: 'Maried',
            childrens: 0,
            revenue: 0
        }

        /*openKochise() {
            if(AuthModule.isSubscribed) {
                let lastsubscription = AuthModule.subscriptions.slice(-1)[0];
                //@ts-ignore
                const start = new Date(lastsubscription.start_at);
                //@ts-ignore
                const end = new Date(lastsubscription.end_at);
                //@ts-ignore
                const diffTime = Math.abs(end - start);
                const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
                console.log(diffDays);
                if(diffDays >= 365) {
                    if(AuthModule.isKochise) {
                        return this.kochise = true;
                    }
                    return this.notKochiseActivated = true;
                } else {
                    return this.notAnnual = true;
                }
            }

            return this.notSubscribed = true;
        }*/

        // PROFILE
        getLastname() {
            return AuthModule.lastname;
            // return JSON.parse(localStorage.getItem('userInfo')).displayName
        }


        get exposuresMapping() {
            return exposures;
        }




        getFirstname() {
            return AuthModule.firstname;
            // return JSON.parse(localStorage.getItem('userInfo')).displayName
        }
        getId() {
            return AuthModule.userID;
            // return JSON.parse(localStorage.getItem('userInfo')).displayName
        }

        submitSimulation() {
            //@ts-ignore
            this.$refs.kochiseForm.$el.submit()
        }

        simulation: any = {
            familySituation: 'Célibataire/Divorcé',
            childrens: 1,
            pay: 80000,
            personnal_apport: 10000,
            credit: 0,
            credit_duration: 25,
            credit_rate: 3,
            rent: 0,
            surface: 0,
            gestion: 12,
            tax: 20,
            tax_exoneration: 10,
            copro: 60,
            reval_immo: 1,
            reval_rent: 1,
            lotSelected: null
        }

        result: any = null;
        resultModal: any = null;
        openModal: boolean = false;
        chargingKochise: boolean = true;
        openSendDocModal: boolean = false;
        simLotSelected: any = null;

        async downloadDocs() {
            if(this.lotsSelected.length > 5) {
                const $vs = (this as any).$vs;
                $vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: "Vous ne pouvez pas séléctionner plus de 5 lots",
                });
                return false;
            }
            let programName = this.program.name;
            let companyName = this.program.promoter.name;
            let filename = `${companyName}_${programName}.zip`;
            postLotsArchivePrescriber({
                lots: this.lotsSelected.map(lot => lot.id || -1),
            })
                .then(({ data }) => {
                    saveAs(data, filename);
                })
                .catch(async error => {
                    const $vs = (this as any).$vs;
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Erreur',
                        text: JSON.parse(await error.response.data.text()).message,
                    });

                    if (error.response.status === 403) {
                        location.reload();
                    }
                });
        }

        async lotSelect(lot: Lot) {
            console.log(this.lotsSelected);
            if(lot && this.lotsSelected.find(x => x.id === lot.id)) {
                //@ts-ignore
                const index = this.lotsSelected.indexOf(lot);
                if (index > -1) {
                    this.lotsSelected.splice(index, 1);
                }
            } else {
                this.lotsSelected.push(lot);
            }
        }

        isLotSelected(lot: Lot) {
            const el = this.lotsSelected.find(x => x.id === lot.id);
            return el !== undefined;
        }

        get customerFamilyArr() {
            return Object.keys(families).map(key => ({
                text: (families as any)[key],
                value: key,
            }));
        }

        get getOptionInfos() {
            return getOptionInfos;
        }

        async OpenModal(type: any) {
            if(type) {
                if(type == 6) {
                    console.log('result 6')
                    this.resultModal = this.result.resultats6Ans
                }
                if(type == 9) {
                    this.resultModal = this.result.resultats9Ans
                }
                if(type == 12) {
                    this.resultModal = this.result.resultats12Ans
                }
                this.resultModal.type = type;
            }
            this.openModal = true;
            console.log(this.resultModal)
            console.log(type)
        }

        async OpenSendDocModal(type: any){
            this.openSendDocModal = true;
        }

        @Watch('simulation', { deep: true })
        async onSimulation() {
            this.chargingKochise = true;
            if(this.simulation.pay && this.simulation.credit_rate && this.simulation.lotSelected) {
                try {
                    const {data} = await getKochise(this.simulation);
                    this.result = data;
                } catch {
                    const $vs = (this as any).$vs;
                    $vs.notify({
                        color: 'danger',
                        position: 'top-right',
                        title: 'Erreur',
                        text: "Nous ne trouvons aucun résultats pour ce lot.. Vérifiez que toutes les infos relatives à la simulation soient présentes",
                    });
                    this.chargingKochise = false;
                    return false;
                }
            }
            this.chargingKochise = false;
        }

        @Watch('simLotSelected', { deep: true })
        async onSimLotSelected() {
            if(this.simLotSelected) {
                if(this.simLotSelected.rent_limit_pk_included) {
                    this.simulation.rent = this.simLotSelected.rent_limit_pk_included;
                }
                if(this.simLotSelected.surface_carrez) {
                    this.simulation.surface = this.simLotSelected.surface_carrez;
                }
                if(this.simLotSelected.price) {
                    this.simulation.credit = this.simLotSelected.price;
                }
                this.simulation.lotSelected = this.simLotSelected.id;
            }
        }


        async created() {
            if (this.program.lowest_price && this.program.highest_price) {
                const step = 50 * 1000;

                const start = Math.floor(this.program.lowest_price / step) * step;
                const end = Math.ceil(this.program.highest_price / step) * step;

                this.marks = {};
                const values = range(start, end + step, step);
                for (const val of values) {
                    this.marks[val] = formatPrice(val);
                }

                this.min = start;
                this.max = end;

                this.defaultValue = [
                    this.program.lowest_price,
                    this.program.highest_price,
                ];
                this.rangeValue = this.defaultValue;
            }

            await this.fetch();
        }

        tipFormatter(value: number) {
            return formatPrice(value);
        }

        async afterChange() {
            if (!this.rangeValue) {
                return;
            }

            this.meta.filters.price = {
                min: this.rangeValue[0],
                max: this.rangeValue[1],
            };
            this.meta.page = 0;

            // Petit hack pour fixer ça : https://github.com/vueComponent/ant-design-vue/issues/1211
            const $slider = this.$refs.slider as HTMLDivElement;
            $slider.focus();

            await this.fetch();
        }

        async fetch() {
            if (!this.program || !this.program.id) {
                return;
            }

            this.loadingContent = true;
            try {
                const { data } = await getLotsPrescriber(this.program.id, this.meta);
                this.lots = data.data;
                this.meta.total = data.meta.total;
                this.meta.pages = data.meta.pages;
                this.meta.page = data.meta.page;
            } catch (e) {
                (this as any).$vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: 'Impossible de charger les lots.',
                });
            } finally {
                this.loadingContent = false;
            }
        }

        async goToPage(page: number) {
            if (page < 0 || page >= this.meta.pages) return;
            this.meta.page = page;
            await this.fetch();
        }

        get hasReducedPrice() {
    return this.includesTaxes([7]);
}

        get hasBrsPrice() {
            if (this.lots) {
                for (let i = 0; i < this.lots.length; i++) {
                    if (this.lots[i].price_reduced_brs > 0){
                        return true;
                    }
                }
            }
            return false;
        }

        get hasLliPrice() {
    return this.includesTaxes([10]);
}

get hasNueProPrice() {
    return this.includesTaxes([4]);
}

get hasReventeTaxSystem() {
    if (!this.program || !this.program.tax_system || this.program.tax_system.length < 1) {
        return false;
    }
    
    const reventeTaxSystems = [
        'Revente LMNP',
        'Revente LMNP Tourisme',
        'Revente LMNP Étudiant',
        'Revente LMNP Sénior',
        'Revente LMNP Rés',
        'Revente LMNP EHPAD'
    ];
    
    return this.program.tax_system.some(taxSystem => 
        reventeTaxSystems.includes(taxSystem)
    );
}

get shouldShowLmnpTvaRecup() {
    return this.includesTaxes([3]) && !this.hasReventeTaxSystem;
}

        sortBy(value: string) {
            let orderWay: 'DESC' | 'ASC' | null = null;
            let orderBy = null;

            if (this.meta.orderBy === value) {
                switch (this.meta.orderWay) {
                    default:
                        orderBy = value;
                        orderWay = 'DESC';
                        break;
                    case 'DESC':
                        orderBy = value;
                        orderWay = 'ASC';
                        break;
                    case 'ASC':
                        orderBy = null;
                        orderWay = null;
                        break;
                }
            } else {
                orderBy = value;
                orderWay = 'DESC';
            }

            this.meta = {
                ...this.meta,
                orderWay,
                orderBy,
                page: 0,
            };

            this.fetch();
        }

        async filterByType(value: string) {
            if (value === null) {
                this.meta.filters.type = null;
            } else {
                this.meta.filters.type = [value];
            }

            await this.fetch();
        }

        async filterByType2(value: string) {
            if (value === null) {
                this.meta.filters.type2 = null;
            } else {
                this.meta.filters.type2 = [value];
            }

            await this.fetch();
        }

        includesTaxes(values: number[]) {
            if (this.tax_system_category) {
                //console.log(values)
                for (let index in values) {
                    if (this.tax_system_category.includes(values[index])) {
                        return true;
                    }
                }
            }
            return false;
        }


                            // New Function For the Report GEneration ****************
                
                reportModalActive: boolean = false;

                openReportModal() {
                    this.reportModalActive = true;
                }

                handleReportGeneration(reportConfig: any) {
                    console.log('Generating PDF with config:', reportConfig);
                    
                    // @ts-ignore
                    this.$vs.notify({
                        color: 'success',
                        title: 'Génération en cours',
                        text: 'Le rapport PDF est en cours de génération...'
                    });
                    
                    this.reportModalActive = false;
                }



        get tax_system_category() {
            if (
                !this.program ||
                !this.program.tax_system ||
                this.program.tax_system.length < 1
            ) {
                return;
            }
            let arrayReturn = [];
            let arraytaxSystem = this.program.tax_system;
            // console.log(arraytaxSystem)
            //const firstTaxSystem = program.tax_system[0];
            for (let i = 0; i < arraytaxSystem.length; i++) {
                if (
                    [
                        'Pinel / Rés. principale',
                        'PLS',
                        'PINEL Sénior',
                        'PINEL Outre Mer',
                    ].includes(arraytaxSystem[i])
                ) {
                    //console.log('tax_system_category: 1');
                    arrayReturn.push(1);
                } else if (
                    [
                        'Denormandie',
                        'Malraux',
                        'PINEL Ancien',
                        'Monuments historiques',
                        'Déficits fonciers',
                        'Loi COSSE Ancien-Louer Abordable',
                    ].includes(arraytaxSystem[i])
                ) {
                    //console.log('tax_system_category: 2');
                    arrayReturn.push(2);
                } else if (
                    [
                        'LMNP VEFA Divers',
                        'LMNP Étudiant',
                        'LMNP Senior',
                        'LMNP Tourisme',
                        'LMNP EHPAD',
                        'LMNP Coliving',
                        'LMNP Colocation',
                        'LMNP CRT',
                        'CIIC Corse',
                        'Revente LMNP',
                        'Revente LMNP Tourisme',
                        'Revente LMNP Étudiant',
                        'Revente LMNP Sénior',
                        'Revente LMNP Rés',
                        'Revente LMNP EHPAD'
                    ].includes(arraytaxSystem[i])
                ) {
                    //   console.log('tax_system_category: 3');
                    arrayReturn.push(3);
                } else if (arraytaxSystem[i] === 'Démembrement de propriété') {
                    //console.log('tax_system_category: 4');
                    arrayReturn.push(4);
                } else if (arraytaxSystem[i] === 'Projet construction') {
                    //console.log('tax_system_category: 5');
                    arrayReturn.push(5);
                } else if (arraytaxSystem[i] === 'Revente fin défiscalisation') {
                    //console.log('tax_system_category: 6');
                    arrayReturn.push(6);
                } else if (arraytaxSystem[i] === 'RP Tva Réduite/Prix Maitrisé') {
                    //console.log('tax_system_category: 7');
                    arrayReturn.push(7);
                } else if (arraytaxSystem[i] === 'Denormandie') {
                    //console.log('tax_system_category: 8');
                    arrayReturn.push(8);
                }
                else if (arraytaxSystem[i] === 'BRS') {
                    // Using category 9 since categories 1-8 are already used
                    arrayReturn.push(9);
                }
                else if (arraytaxSystem[i] === 'LLI') {
                    //console.log('tax_system_category: 10');
                    arrayReturn.push(10);
                }
            }
            return arrayReturn;
            //return null;
        }

    }
